module.exports = __webpack_public_path__ + "static/subset-UniNeueBook-ba00b831ebd46474b51a5b195fe3da75.woff";